import { Directive, ElementRef, Input, OnInit } from "@angular/core";

@Directive({
    selector: "[elementFocus]"
})

export class ElementFocus implements OnInit {

    @Input() elementFocus:boolean;

    constructor(private _el: ElementRef) {

    }

    ngOnInit(): any {
        // At this point, your element should be available.
        //console.log('this._el.nativeElement',this._el.nativeElement);
        if(this.elementFocus) {
            this._el.nativeElement.focus();
        }
    }
}


// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/directives/element-focus.directive.ts